<template lang="pug">
span
  VMenu.index-study-menu(v-if="indexComputed.count")
    template(#activator="activatorProps")
      slot(
        name="activator"
        v-bind="{ activatorProps, countLocale: indexComputed.countLocale, count: indexComputed.count, maxCount: indexComputed.maxCount }"
      )
        VBtn.text-black(
          v-bind="activatorProps['props']"
          color="secondary-c500"
          data-testid="studyThisVerseButton"
          :variant="indexComputed.countLocale > 0 ? 'flat' : 'outlined'"
        )
          VIcon {{ commentaryOutline }}
          | {{ i18n.t("Global.study") }}
    VList
      VListItem(
        v-for="{ commentaryType, countData } in indexComputed.commentaryTypes"
        :key="commentaryType.machineName"
        :to="localePath(getCommentaryLocationFromRange(commentaryType.machineName, indexComputed.range, inline ? detailLevelWeight : undefined, locale))"
        @click="onCommentaryTypeClick"
      )
        template(#prepend)
          CommentaryTypeIcon(
            :machine-name="commentaryType.machineName"
            variant="outline"
          )
        VListItemTitle {{ commentaryType.name[locale] }}
        template(#append)
          VChip.ml-4(
            size="small"
            :color="countData.countLocal > 0 ? 'secondary-c500' : dark ? 'primary-c100' : 'primary-c700'"
            :variant="countData.countLocal > 0 ? 'flat' : 'text'"
          )
            span(v-html="countData.countHtml")
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { TranslationAgnosticVidRange } from "~/units/scripture";
import { getCommentaryLocationFromRange } from "~/routing/locations";
import { usePreferencesStore } from "~/stores/usePreferencesStore";
import { useVersePreviewStore } from "~/stores/useVersePreviewStore";
import { commentaryOutline } from "~/icons";
import { injectRequired } from "~/injectRequired";
import { SolrClientKey } from "~/injectionKeys";
import { useModalRouterUtils } from "~/composables/useModalRouterUtils";
import { useCommentaryFiltersStore } from "~/stores/useCommentaryFiltersStore";
import { useDarkMode } from "~/composables/useDarkMode";

const solrClient = injectRequired(SolrClientKey);
const dark = useDarkMode();
const i18n = useI18n();
const localePath = useLocalePath();
const preferencesStore = usePreferencesStore();
const versePreviewStore = useVersePreviewStore();
const { onClickLinkCanGoOutsideModal } = useModalRouterUtils();

const locale = i18n.locale;

interface Props {
  range: TranslationAgnosticVidRange;
  inline?: boolean;
}

const props = defineProps<Props>();
const commentaryFilters = useCommentaryFiltersStore();
const runtime = useRuntimeConfig();
const detailLevelWeight = computed(
  () =>
    commentaryFilters.getDetailLevel(
      runtime.public.commentary.defaultDetailLevelWeight,
    ).weight,
);

/**
 * In context of modal view
 */
function onCommentaryTypeClick(e: MouseEvent | TouchEvent | KeyboardEvent) {
  const cleaned = onClickLinkCanGoOutsideModal(e, !props.inline);
  if (cleaned) {
    // Close the verse preview if the modal is closed.
    versePreviewStore.close();
  }
}

const { index, indexComputed } = useCommentaryIndexAndTypeCountFromRange({
  range: props.range,
});
</script>
